var map = {
	"./barokk/sirkel_barokk.png": "ab30",
	"./humanisme/sirkel_humanisme.png": "9106",
	"./modernisme/sirkel_modernisme.png": "0789",
	"./norron/banner_norron.png": "a6b5",
	"./norron/sirkel_norron.png": "e014",
	"./nyrealisme/sirkel_nyrealisme.png": "1045",
	"./nyromantikk/sirkel_nyromantikk.png": "1f7b",
	"./opplysning/sirkel_opplysning.png": "b7ba",
	"./postmodernisme/sirkel_postmodernisme.png": "2b76",
	"./realisme/sirkel_realisme.png": "e329",
	"./romantikk/sirkel_romantikk.png": "e76c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fa5c";